module.exports = __webpack_public_path__ + "static/media/detska-strava.cd933d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/detska-strava.png
// module id = 411
// module chunks = 0